export default async ({ next, store }) => {
    await store.dispatch('getUserInfo') // need to wait until load data to vuex store

    if (store.getters.currentUser.info.subscription
        && store.getters.currentUser.info.subscription.plan.name === 'Require pay plan'
    ) {
        return next({
            name: 'billing',
        })
    }
}
